import Vue2 from 'vue/dist/vue.common.js'
import moment from 'moment'

// Define time filter here so we can use moment without injecting moment into component.
// * Local filter methods are not within the scope of vue instance.
Vue2.filter('calendarTime', function (value) {
  return moment(value)
    .calendar(null, {
      sameDay() {
        return '[' + this.fromNow() + ']'
      },
      nextDay: '[Tomorrow]',
      nextWeek: 'dddd',
      lastDay: '[Yesterday at] h:mm A',
      lastWeek: '[Last] dddd [at] h:mm A',
      sameElse: window.momentDateFormat,
    })
})

Vue2.filter('snakeToTitle', function (str) {
  return str.split('_').map(function (item) {
    return item.charAt(0).toUpperCase() + item.substring(1)
  }).join(' ')
})